import { postMessageToTopmostFrame } from '../network/postMessage';

/**
 * Helper class for bubbling up client script click event to the top frame from inner iframe.
 * @module frames/IFrameClickEventHelper
 */

/**
 * Allows click events to bubble up to the parent frame.
 */
export const registerDocumentClickBubblingOnTop = () => {
    const deviceAgent = navigator.userAgent.toLowerCase();
    const agentId = deviceAgent.match(/(iphone|ipod|ipad)/);

    const iframeClickBubbleMessage = { messageName: 'iframeClickBubble' };
    document.addEventListener('click', () => { postMessageToTopmostFrame(iframeClickBubbleMessage); });

    if (!agentId) {
        const iframeTouchstartBubbleMessage = { messageName: 'iframeTouchstartBubble' };
        document.addEventListener('touchstart', () => { postMessageToTopmostFrame(iframeTouchstartBubbleMessage); });
    }
};